import { useMutation, useQueryClient } from '@tanstack/react-query';
import { lacCostLimitService } from '../../../services/LacCostLimitService';
import { lacQueryKeys } from '../lacQueryKeys';

export function useSaveLacCostLimitMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      tenantName,
      monthlyLimit,
      yearlyLimit,
    }: {
      tenantName: string;
      monthlyLimit: number | null;
      yearlyLimit: number | null;
    }) =>
      lacCostLimitService.saveCostLimit(tenantName, monthlyLimit, yearlyLimit),
    onSuccess: (_result, variables) => {
      void queryClient.invalidateQueries({
        queryKey: lacQueryKeys.costLimit(variables.tenantName),
      });
      void queryClient.invalidateQueries({
        queryKey: lacQueryKeys.costLimits(),
      });
    },
  });
}
